import React from 'react'
import './CodeFalconContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaGlobe, FaLock, FaBolt, FaTools, FaBox, FaUnlock } from 'react-icons/fa'

export class CodeFalconContent extends React.Component {
  render() {
    return (
      <div className="code-falcon-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Code Falcon is an open-source Virtual Desktop Infrastructure (VDI)
            solution that empowers DoD software engineers with secure,
            browser-based access to fully-equipped virtual development
            environments - no thick clients, no privilege barriers.
          </div>
        </div>

        <section className="padding-large">
          <h2>The Problem</h2>
          <div className="problem-statement">
            <p>
              NIPR users are frequently blocked from installing essential software
              development tools like Docker, VSCode, and Platform One resources due
              to DAF and local security policies. Existing commercial VDI solutions
              require thick clients, don't pass user privileges to the VM, and carry
              significant licensing or cloud costs. These "tool access denied"
              scenarios frustrate developers, reduce productivity, and make it
              harder for the DoD to attract and retain top software engineering
              talent.
            </p>
          </div>
        </section>

        <div className="split pattern">
          <h2>Key Features</h2>
          <div className="row features-grid">
            <div className="col-md-4">
              <div className="feature-item">
                <div className="icon"><FaGlobe /></div>
                <div className="title">Browser-Based Access</div>
                <div className="description">
                  Access virtual desktops from any approved DODIN device using
                  just your browser - no thick client required
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item">
                <div className="icon"><FaLock /></div>
                <div className="title">CAC Authentication</div>
                <div className="description">
                  Innovative Common Access Card authentication directly within
                  the browser-based VDI for secure access
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item">
                <div className="icon"><FaBolt /></div>
                <div className="title">Dynamic VM Management</div>
                <div className="description">
                  Automated creation and deletion of virtual desktops using
                  Terraform operators and KubeVirt
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item">
                <div className="icon"><FaTools /></div>
                <div className="title">Pre-Configured Environments</div>
                <div className="description">
                  Full Linux environments with VSCode, Docker, and popular
                  language runtimes ready to use
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item">
                <div className="icon"><FaBox /></div>
                <div className="title">Custom VM Catalog</div>
                <div className="description">
                  Private catalog of customized Windows and Linux VM images
                  centrally managed by Platform One
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-item">
                <div className="icon"><FaUnlock /></div>
                <div className="title">Open Source Foundation</div>
                <div className="description">
                  Built on Apache Guacamole - avoid vendor lock-in and reduce
                  long-term licensing costs
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <div className="row">
            <div className="col-md-6">
              <h2>Technology Stack</h2>
              <ul className="tech-list">
                <li>Apache Guacamole for browser-based remote desktop</li>
                <li>KubeVirt for VM orchestration on Kubernetes</li>
                <li>Terraform operators for infrastructure automation</li>
                <li>RDP, VNC, and SPICE protocol support</li>
                <li>Integration with Platform One tools (Big Bang, Iron Bank, GitLab)</li>
              </ul>
            </div>
            <div className="col-md-6">
              <h2>Benefits</h2>
              <ul className="benefits-list">
                <li>Eliminate "tool access denied" developer frustration</li>
                <li>Improve DoD software engineering productivity</li>
                <li>Attract and retain top development talent</li>
                <li>Reduce licensing and infrastructure costs</li>
                <li>Seamless Platform One ecosystem integration</li>
              </ul>
            </div>
          </div>
        </section>

        <div className="split light">
          <h2>Fast Acquisition</h2>
          <div className="text-wrap centered">
            <p>
              Code Falcon is available for competitive or direct award on the
              Platform One Marketplace, enabling acquisition in as few as 30 days.
            </p>
          </div>
          <div className="marketplace-logos">
            <img src="/p1-marketplace.png" alt="Platform One Marketplace" />
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Get Started
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default CodeFalconContent
